import { HeadlineType } from '../resourceContentUtils';

interface ArticleHeadlineProps {
  headline: string;
  headlineType: HeadlineType;
}

export const ArticleHeadline = ({
  headline,
  headlineType,
}: ArticleHeadlineProps) => {
  switch (headlineType) {
    case 'h1':
      return <h1 className="text-lg font-medium mb-4 text-bold pt-6">{headline}</h1>;
    case 'h2':
      return <h2 className="text-lg font-medium mb-3 text-bold pt-6">{headline}</h2>;
    case 'h3':
      return <h3 className="text-lg font-medium mb-2 text-bold pt-6">{headline}</h3>;
    case 'h4':
      return <h4 className="text-md font-medium mb-2 text-bold pt-6">{headline}</h4>;
    default:
      return null; // Or some default rendering for unsupported types
  }
};
